import React from "react";
import { useState } from "react";
import { Box, Typography, useTheme, Grid2, Radio, RadioGroup, FormControlLabel, FormControl } from "@mui/material";
import { useParams } from "react-router-dom";
import HighchartsReact from "highcharts-react-official";
import Highcharts, { color } from "highcharts";
import { fontWeight, letterSpacing, lineHeight, width } from "@mui/system";
import { useGetNonPerformingQuery } from "store/slices/apis/VendorDashboardSlice";



const legendData = [

    { label: "R4", color: "#006045" },
    { label: "R5", color: "#FDCA41" },

]

const NonPerformingVendors = () => {
    const theme = useTheme();
    const { projectId } = useParams();

    const [supplierType, setSupplierType] = useState("material");


    const { data, isLoading, error } = useGetNonPerformingQuery({ projectId, supplierType })

    const vendorName = data?.map((item) => item.vendorName)


    const backgroundSeriesData = data?.map(() => ({
        y: 100,
        color: "#DDDFE3",
    }));



    const getRatingValue = (rating) => {
        switch (rating) {
            case "R1": return 20;
            case "R2": return 40;
            case "R3": return 60;
            case "R4": return 80;
            case "R5": return 100;
            default: return 0;
        }
    };


    const actualSeriesData = data?.map((item) => {
        let color = "";

        if (item.overallRating === "R4") {
            color = "#006045";
        } else if (item.overallRating === "R5") {
            color = "#FDCA41";
        } else {
            color = "#CE412D";
        }

        return {
            y: getRatingValue(item.overallRating),
            color: color,
            name: item.vendorName,
        };
    });


    const chartOptions = {
        chart: {
            type: "bar",
            height: 300,
            marginBottom: 0,
            spacingTop: 0,
            marginRight: 0,
            marginTop: 24
        },
        title: { text: "" },
        xAxis: {
            categories: vendorName,
            lineWidth: 0,
            tickLength: 0,
            offset: 40,
            labels: {
                style: {
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "100%",
                    letterSpacing: "-0.4px",
                    color: "#182A4E",
                },
            },
        },
        yAxis: {
            min: 0,
            max: 100,
            tickInterval: 20,
            tickLength: 5,
            tickWidth: 1,
            tickColor: "#758195",
            gridLineWidth: 0,
            opposite: true,
            lineColor: "#7581954D",
            lineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value === 20) return "R1";
                    if (this.value === 40) return "R2";
                    if (this.value === 60) return "R3";
                    if (this.value === 80) return "R4";
                    if (this.value === 100) return "R5";
                    return "";
                },
                style: {
                    fontSize: "12px",
                    color: "#414D55",
                },
            },
        },
        legend: {
            enabled: false
        },
        tooltip: {
            formatter: function () {
                return `<b>${this.point.name}</b>: ${this.point.y}%`;
            },
            backgroundColor: '#fff',
            borderColor: '#ccc',
            style: {
                color: '#000',
                fontSize: '13px'
            }
        },
        plotOptions: {
            series: {
                grouping: false,
                dataLabels: {
                    enabled: false,
                    // inside: true,
                    // align: "right",
                    // x: -10,
                    // verticalAlign: "middle",
                    // style: {
                    //     fontSize: "13px",
                    //     fontWeight: 600,
                    //     color: "#fff",
                    //     textOutline: "none",
                    // },
                },
            },
        },
        series: [
            {
                name: "Background",
                data: backgroundSeriesData,
                enableMouseTracking: false,
                showInLegend: false,
                dataLabels: {
                    enabled: false
                }
            },
            {
                name: "Vendor Progress",
                data: actualSeriesData,
                showInLegend: false
            },
        ],
        credits: { enabled: false },
    };

    return (
        <Box
            sx={{
                padding: 2,
                background: "#fff",
                borderRadius: 2,
                border: '1px solid #2525252E',
                mb: 2,
                height: { xs: 'auto', md: '423px' },
                minHeight: "100%",
                width: "100%"
            }}
        >
            <Grid2
                container
                sx={{
                    width: "100%",
                    flexDirection: { xs: "column", md: "row" },
                    gap: { xs: 2, md: 0 },
                }}
            >
                <Grid2 size={{ xs: 12, md: 8 }}>
                    <Typography
                        variant="body"
                        sx={{
                            fontWeight: 500,
                            fontSize: "17px",
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                            color: `${theme?.customSettings?.themeColor}`,
                        }}
                    >
                        Non Performing Vendors
                    </Typography>
                    <Typography
                        sx={{
                            mt: "5px",
                            color: "#5052588A",
                            fontSize: "16px",
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                        }}
                    >
                        Identify underperforming vendors to initiate corrective actions and mitigate risks.
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                        {legendData.map(item => (
                            <Box key={item.label} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    width: 13,
                                    height: 13,
                                    backgroundColor: item.color,
                                    marginRight: '5px'
                                }}></Box>
                                <Typography sx={{
                                    fontSize: '15px',
                                    fontWeight: 500,
                                    color: '#182A4E'
                                }}>
                                    {item.label}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' }, alignItems: 'flex-start' }}>
                    <FormControl component="fieldset">
                        <RadioGroup
                            row
                            value={supplierType}
                            onChange={(e) => setSupplierType(e.target.value)}
                        >
                            <FormControlLabel
                                value="material"
                                control={<Radio />}
                                label="Material Supplier"
                            />
                            <FormControlLabel
                                value="services"
                                control={<Radio />}
                                label="Services Supplier"
                            />
                        </RadioGroup>
                    </FormControl>
                </Grid2>
            </Grid2>
            <Grid2 container sx={{ mt: "10px" }}>
                <Grid2 xs={12} md={6} lg={6}>
                    <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default NonPerformingVendors;

